// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__11geN","savePackageButton":"ClientWallet_savePackageButton__2dCb6"};